import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

interface UpdateObj {
  stainColor?: string;
  customPaintOrStain?: string;
  stain?: string;
}

function useStainSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const stainChoice = useStore((state) => state.quote.stain);
  const customStain = useStore((state) => state.quote.customPaintOrStain);
  const customStainColor = useStore((state) => state.quote.customStainColor);

  const btnChoice = stainChoice || customStain || "";

  const stainColor = useStore((state) => state.quote.stainColor);

  const material = useStore((state) => state.quote.material);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handleClick = (label: string, type: string) => {
    const checked = label === btnChoice;

    if (checked) {
      addToQuote({ [type]: "" }, type);
    } else {
      let update: UpdateObj = { [type]: label };
      let ignoreResetKey = "";

      if (type !== "customPaintOrStain") {
        update["customPaintOrStain"] = "";

        if (customStain) {
          ignoreResetKey = "customPaintOrStain";
        }
      } else {
        update["stain"] = "";

        if (stainChoice) {
          ignoreResetKey = "stain";
        }
      }

      addToQuote(update, ignoreResetKey);
    }
  };

  const handleClickColor = (label: string) => {
    const checked = label === stainColor;

    if (checked) {
      addToQuote({ stainColor: "" });
    } else {
      addToQuote({ stainColor: label });

      if (findRequired("Stain Color")) removeRequired("Stain Color");
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    if (value.length <= 15) {
      addToQuote({ customStainColor: value });

      if (findRequired("Custom Stain Color"))
        removeRequired("Custom Stain Color");
    }
  };

  const standardStainSelected = btnChoice === "Add Standard Stain";

  const customStainSelected = btnChoice === "Add Custom Stain";

  return {
    customStainSelected,
    standardStainSelected,
    handleChange,
    handleClickColor,
    handleClick,
    material,
    customStainColor,
    stainChoice,
    customStain,
    btnChoice,
    stainColor
  };
}

export default useStainSelector;
